import { Box, Button, SvgIcon, Toolbar } from '@mui/material';
import FileDownload from 'mdi-react/FileDownloadIcon';
import { func, string } from 'prop-types';
import React, { Component } from 'react';
import { I18n } from 'utils/i18n';
import ErrorCaption from './ErrorCaption';
import Search from './Search';

class EnhancedTableToolbar extends Component {
  state = {
    searchValue: '',
  };

  handleSearch = e => {
    const { onSearch } = this.props;
    this.setState({ searchValue: e.target.value });
    onSearch(e.target.value);
  };

  render() {
    const { error, onExport } = this.props;
    return (
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          pr: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: 'text.secondary',
          }}
        >
          <ErrorCaption>{error}</ErrorCaption>
          <Search onChange={this.handleSearch} value={this.state.searchValue} />
          <Button
            variant="outlined"
            color="secondary"
            sx={{
              color: 'primary.ultraDark',
              ml: '10px',
            }}
            onClick={onExport}
          >
            <SvgIcon
              sx={{
                fontSize: 18,
                mr: '5px',
                color: 'primary.main',
              }}
            >
              <FileDownload />
            </SvgIcon>
            {I18n.t('FormAnalyticsDrawer.EmployeesTable.Export responses')}
          </Button>
        </Box>
      </Toolbar>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  error: string,
  onSearch: func.isRequired,
  onExport: func.isRequired,
};

EnhancedTableToolbar.defaultProps = {
  error: '',
};

export default EnhancedTableToolbar;
